import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from './../../../assets/images/attachment.png'


const _hoisted_1 = {
  key: 0,
  class: "gd-attachment mb-gutter"
}
const _hoisted_2 = { class: "mb-gutter" }
const _hoisted_3 = { class: "gd-file-list font-small" }
const _hoisted_4 = { class: "list-styled" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "legal__attachment"
}, null, -1)
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "legal__attachmenttext" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.sarMgmtModel.CurrentAttachments != null)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t("labeltext.attachments")), 1)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("ul", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sarMgmtModel.CurrentAttachments, (attachment, index) => {
              return (_openBlock(), _createElementBlock("li", { key: index }, [
                _hoisted_5,
                _createElementVNode("a", {
                  onClick: ($event: any) => (_ctx.downloadAttachments(attachment.FileGuid, attachment.FileName)),
                  class: "legal__attachmentlist"
                }, _toDisplayString(attachment.FileName), 9, _hoisted_6),
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.getLegalAttachmentText(attachment)), 1),
                _createElementVNode("div", null, [
                  _createElementVNode("span", null, _toDisplayString(attachment.DocumentTitle), 1)
                ])
              ]))
            }), 128))
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}